import axios from "axios";
import React, { ReactElement } from "react";
import { useMutation } from "react-query";
import { useHistory, RouteComponentProps } from "react-router-dom";
import Button from "../../Button/Button";
import nrLogo from "../Login/NRLogoLarge.png";
import dfLogo from "./DFLogoLarge.png";
import Text from "../../Text/Text";
import styles from "./AcceptTerms.module.css";
import { Logout } from "../Session";

export const COMPUTER_MISUSE_ACT_PDF_URL = "https://networkrailmobile-railauth.s3.eu-west-1.amazonaws.com/assets/ComputerMisuseAct.pdf";

interface VerifyLoginProps extends RouteComponentProps<any> {
  customAxiosInstance?: any;
  termsAndConditionsUrl: string;
  firstLogin: boolean;
  railAuthApiUrl: string;
  termsAndCondToken: string;
  appName: string;
}

const AcceptTerms: React.FC<VerifyLoginProps> = ({
  firstLogin,
  termsAndConditionsUrl,
  termsAndCondToken,
  customAxiosInstance,
  railAuthApiUrl,
  appName,
}): ReactElement => {
  const axiosInstance = customAxiosInstance || axios;
  const history = useHistory();

  const [acceptTerms] = useMutation(
    () =>
      axiosInstance.post(
        "terms-and-conditions/accept",
        { termsAndCondToken },
        {
          baseURL: `${railAuthApiUrl}/api/`,
        }
      ),
    {
      onSuccess: (response: any) => {
        localStorage.setItem("authenticated", JSON.stringify(response.data.accessToken));
        localStorage.setItem("refreshToken", JSON.stringify(response.data.refreshToken));
        localStorage.setItem("user", JSON.stringify(response.data.user));
        history.push("/");
      },
      onError: () => {
        Logout();
        history.push("/");
      },
    }
  );

  return (
    <div className={styles.panel}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={nrLogo} alt="Network Rail" />
        </div>
        <div className={styles.header}>
          <label className={styles.sub_title}>Network Rail Security Warning Notice</label>
          <h2 className={styles.title}>
            {firstLogin ? "Terms and conditions" : "Terms and conditions have changed"}
          </h2>
        </div>
        <div className={styles.form_inputs}>
          <Text type="body" size="16px">
            {firstLogin
              ? `Welcome to ${appName}.`
              : "The new version of terms and conditions for this app is now available."}
          </Text>
          <Text type="body" size="16px">
            Please make sure you read and understand the latest{" "}
            <a href={termsAndConditionsUrl} target="_blank" className={styles.link}>
              Terms and Conditions
            </a>{" "}
            and{" "}
            <a href={COMPUTER_MISUSE_ACT_PDF_URL} target="_blank" className={styles.link}>
              Computer Misuse Act
            </a>{" "}
            and click ‘Accept Terms and Conditions’ button on this page to be able to procceed into{" "}
            {appName} or press ‘Reject Terms and Conditions’ if you do not agree to the new terms,
            but please note you will be logged out from {appName} and may be asked to accept the new
            terms and the app misuse act upon next login.
          </Text>
        </div>
        <div className={styles.form_buttons}>
          <Button
            name="cancelClient"
            text="Reject Terms and Conditions"
            color="blue"
            type="button"
            className={styles.reject_button}
            onClick={() => {
              Logout();
              history.push("/");
            }}
          />
          <Button
            name="registerNewClient"
            text="Accept Terms and Conditions"
            color="blue"
            className={styles.accept_button}
            onClick={() => {
              acceptTerms();
            }}
          />
        </div>
      </div>
      <div className={styles.footer}>
        <img src={dfLogo} className={styles.df_logo} alt="Digital Factory" />

        <Text
          type="body"
          size="10px"
          style={{ justifySelf: "center", letterSpacing: "1.5px", fontWeight: 700 }}
        >
          Visit us at{" "}
          <a href="https://www.nrdigital.co" target="_blank" className={styles.link_footer}>
            www.nrdigital.co
          </a>{" "}
          to learn more about the Digital Factory!
        </Text>
      </div>
    </div>
  );
};

export default AcceptTerms;
